import React from "react";
import { Tabs } from "antd";

const InfoZoneManagerTabUi = ({ tabId, setTabId }) => {
  return (
    <Tabs
      className="mx-2 text-base"
      popupClassName="mb-0"
      tabBarStyle={{
        marginBottom: 0,
      }}
      activeKey={tabId}
      defaultActiveKey={tabId}
      items={[
        { label: "Info zones", key: "info_zones" },
        { label: "Blocks", key: "blocks" },
      ]}
      onChange={(value) => {
        setTabId(value);
      }}
    />
  );
};

export default InfoZoneManagerTabUi;
